<div class="account-deletion-page">
  <div class="ad-container">

    <header class="ad-header">
      <a routerLink="/" class="ad-brand" aria-label="Bipperz">
        <img src="assets/new-logo-2.png" alt="Bipperz" class="ad-logo" />
      </a>

      <div class="ad-lang-switch">
        <button type="button" class="ad-lang-btn" (click)="switchLang('de')">Deutsch</button>
        <button type="button" class="ad-lang-btn" (click)="switchLang('en')">English</button>
      </div>
    </header>

    <main class="ad-content">
      <h1 class="ad-title">{{ 'account_deletion.title' | translate }}</h1>
      <p class="ad-controller">{{ 'account_deletion.controller' | translate }}</p>

      <p class="ad-intro">{{ 'account_deletion.intro' | translate }}</p>

      <!-- Option 1: in-app -->
      <section class="ad-card">
        <h2>{{ 'account_deletion.option_app.heading' | translate }}</h2>
        <ol>
          <li *ngFor="let step of appSteps" [innerHTML]="'account_deletion.option_app.steps.' + step | translate"></li>
        </ol>
      </section>

      <!-- Option 2: email -->
      <section class="ad-card">
        <h2>{{ 'account_deletion.option_email.heading' | translate }}</h2>
        <p [innerHTML]="'account_deletion.option_email.body' | translate"></p>
      </section>

      <!-- What is deleted -->
      <h2 class="ad-section-title">{{ 'account_deletion.deleted.heading' | translate }}</h2>
      <p>{{ 'account_deletion.deleted.body' | translate }}</p>

      <!-- Retention -->
      <h2 class="ad-section-title">{{ 'account_deletion.retention.heading' | translate }}</h2>
      <p>{{ 'account_deletion.retention.intro' | translate }}</p>

      <table class="ad-table">
        <thead>
          <tr>
            <th>{{ 'account_deletion.retention.col_category' | translate }}</th>
            <th>{{ 'account_deletion.retention.col_retention' | translate }}</th>
            <th>{{ 'account_deletion.retention.col_reason' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of retentionRows">
            <td>{{ row.category }}</td>
            <td>{{ row.retention }}</td>
            <td>{{ row.reason }}</td>
          </tr>
        </tbody>
      </table>

      <p class="ad-muted" [innerHTML]="'account_deletion.retention.note' | translate"></p>
    </main>

    <footer class="ad-footer">
      {{ 'account_deletion.footer' | translate }}
    </footer>

  </div>
</div>
